import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import React, { Component } from "react";

import { AuthenticationSelectors } from "Redux/AuthenticationRedux";
import Avatar from "Components/Avatar";
import BasicModal from "Modals/BasicModal";
import ConfirmationModal from "Modals/ConfirmationModal";
import CropImageModal from "Modals/CropImageModal";
import DescriptionFormModal from "Modals/DescriptionFormModal";
import EditProjectForm from "Forms/EditProjectForm";
import { FileUploadButton } from "Themes/StyledComponents";
import LinksFormModal from "Modals/LinksFormModal";
import LoadingIcon from "Components/LoadingIcon";
import { MainContainer } from "./styles";
import { MdClose } from "react-icons/md";
import SweetAlert from "react-bootstrap-sweetalert";
import UpdateProjectForm from "Forms/UpdateProjectForm";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";

class EditProjectContainer extends Component {
  state = {
    updateError: null,
    editProjectSettings: 0,
    imageType: "avatar",
    errors: {
      deleteProject: null,
      deleteUpdate: null,
      projectUpdate: null,
      deleteImage: null,
    },
    fetching: {
      projectDetails: false,
      projectUpdate: false,
      cropImage: false,
    },
    success: {
      deleteProject: false,
      projectUpdated: false,
    },
    updateToDeleteId: null,
    imageToDeleteId: null,

    file: null,

    projectColor: null,

    saveProject: {
      fetching: false,
      success: false,
      error: null,
    },

    // --- Modal States --- //
    openDeleteModal: false,
    projectIconForm: false,
    openAddImageModal: false,
    openDeleteImageModal: false,
    showCropImageModal: false,
  };

  async componentDidMount() {
    const {
      getProjectDetails,
      getProjectUpdates,
      getProjectResources,
      getProjectImages,
      match: {
        params: { id },
      },
    } = this.props;

    const projectUpdateResolve = {
      onSuccess: () =>
        this.setState((prevState) => ({
          fetching: {
            ...prevState.fetching,
            projectUpdates: false,
          },
        })),
      onFailure: (e) => {
        this.setState((prevState) => ({
          errors: { ...prevState.errors, projectUpdate: "An error occurred" },
        }));
      },
    };

    const resolveProjectImages = {
      onSuccess: () =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectImages: false },
        })),
      onFailure: (e) =>
        this.setState((prevState) => ({
          fetching: { ...prevState.fetching, projectImages: false },
          errors: {
            ...prevState.errors,
            projectImages: "There was an error",
          },
        })),
    };

    await getProjectDetails(id);
    await getProjectUpdates(id, projectUpdateResolve);
    await getProjectResources(id);
    await getProjectImages(id, resolveProjectImages);
  }

  onUpdateSuccess = () => {
    this.setState((prevState) => ({
      formError: null,
      formSuccess: true,
      success: {
        ...prevState.success,
        projectUpdate: true,
      },
    }));
    window.alert("Project updated!");
  };

  onUpdateFailure = (err) => {
    window.alert("Project update failed!");
    this.setState({
      updateError: err,
    });
  };

  deleteProjectSuccess = () => {
    this.setState((prevState) => ({
      openDeleteModal: false,
      success: {
        ...prevState.success,
        delete: true,
      },
    }));
  };

  deleteProjectFailure = (err) => {
    this.setState({
      errors: {
        deleteProject: err.message,
      },
    });
  };

  deleteProject = () => {
    const { deleteProject, projectDetails } = this.props;

    const resolve = {
      onSuccess: () => this.deleteProjectSuccess(),
      onFailure: (err) => this.deleteProjectFailure(err),
    };

    deleteProject(projectDetails.id, resolve);
  };

  renderDeleteProjectConfirmationModal = () => {
    const { openDeleteModal, errors } = this.state;
    return (
      <ConfirmationModal
        show={openDeleteModal}
        onHide={() =>
          this.setState({
            openDeleteModal: false,
            errors: { deleteProject: null },
          })
        }
        title="Delete Project?"
        icon={<MdClose fontSize={30} color="red" />}
        buttonYes="danger"
        buttonNo="primary"
        onConfirm={() => this.deleteProject()}
        error={errors.deleteProject}
      />
    );
  };

  deleteUpdateSuccess = () => {
    this.setState((prevState) => ({
      confirmDeleteUpdateModal: false,
      success: {
        ...prevState.success,
        deleteUpdate: true,
      },
    }));
  };

  deleteUpdateFailure = (err) => {
    this.setState({
      errors: {
        deleteUpdate: err.message,
      },
    });
  };

  deleteUpdate = (id) => {
    const { deleteUpdate } = this.props;

    const resolve = {
      onSuccess: () => this.deleteUpdateSuccess(),
      onFailure: (err) => this.deleteUpdateFailure(err),
    };

    deleteUpdate(id, resolve);
  };

  renderDeleteUpdateConfirmationModal = () => {
    const { confirmDeleteUpdateModal, errors, updateToDeleteId } = this.state;
    return (
      <ConfirmationModal
        show={confirmDeleteUpdateModal}
        onHide={() =>
          this.setState({
            confirmDeleteUpdateModal: false,
            errors: { deleteUpdate: null },
          })
        }
        title="Delete Update?"
        icon={<MdClose fontSize={30} color="red" />}
        buttonYes="danger"
        buttonNo="primary"
        onConfirm={() => this.deleteUpdate(updateToDeleteId)}
        error={errors.deleteUpdate}
      />
    );
  };

  handleUpdateProject = async (values) => {
    // TODO: Verify if we need this still
    const {
      createProjectUpdate,
      projectDetails: { id },
    } = this.props;

    this.setState((prevState) => ({
      fetching: {
        ...prevState.fetching,
        projectUpdate: true,
      },
    }));

    const resolve = {
      onSuccess: () =>
        this.setState((prevState) => ({
          success: {
            ...prevState.success,
            projectUpdate: true,
          },
        })),
      onFailure: (e) =>
        this.setState((prevState) => ({
          errors: {
            ...prevState.errors,
            projectUpdate: e.detail,
          },
        })),
    };

    const data = {
      id: id,
      update: values.update,
      updateDescription: values.updateDescription,
    };

    await createProjectUpdate(data, resolve);

    this.setState((prevState) => ({
      fetching: {
        ...prevState.fetching,
        projectUpdate: false,
      },
    }));
  };

  confirmDeleteUpdate = (id) => {
    this.setState({
      confirmDeleteUpdateModal: true,
      updateToDeleteId: id,
    });
  };

  changeEditProjectIndex = (idx) => {
    this.setState({
      editProjectSettings: idx,
      formError: null,
      formSuccess: false,
    });

    if (idx === 4) {
      this.setState({
        openDeleteModal: true,
      });
    }
  };

  renderAvatar = () => {
    const { projectDetails, history } = this.props;

    if (!projectDetails.projectManager) return;

    return (
      <Avatar
        user={projectDetails.projectManager}
        text={projectDetails.projectManager.firstName}
        onClick={() =>
          history.push(
            `${navRoutes.profile}/${projectDetails.projectManager.id}`
          )
        }
      />
    );
  };

  renderTimeline = () => {
    const { projectUpdates } = this.props;
    const { errors, fetching, success } = this.state;
    return (
      <UpdateProjectForm
        handleSubmit={this.handleUpdateProject}
        projectUpdates={projectUpdates}
        success={success.projectUpdate}
        error={errors.projectUpdate}
        fetching={fetching.projectUpdate}
        deleteUpdate={this.confirmDeleteUpdate}
      />
    );
  };

  renderLinksFormModal = () => {
    const { openLinksForm } = this.state;
    const { projectDetails } = this.props;
    return (
      <LinksFormModal
        show={openLinksForm}
        onHide={() =>
          this.setState({
            openLinksForm: false,
          })
        }
        projectId={projectDetails.id}
        customIcon={projectDetails.projectAvatar}
      />
    );
  };

  renderDescriptionFormModal = () => {
    const { openDescriptionForm } = this.state;
    return (
      <DescriptionFormModal
        show={openDescriptionForm}
        onHide={() => this.setState({ openDescriptionForm: false })}
      />
    );
  };

  renderProjectIconFormModal = () => {
    const { projectIconForm } = this.state;
    return (
      <BasicModal
        show={projectIconForm}
        onHide={() =>
          this.setState({
            projectIconForm: false,
          })
        }
      >
        <FileUploadButton htmlFor="imgupload">
          Upload an image
          <input
            type="file"
            id="imgupload"
            onChange={this.readUrl}
            name="avatar"
            style={{
              opacity: 0,
              position: "absolute",
              top: 0,
              left: 0,
            }}
            accept="image/png, image/jpeg"
          />
        </FileUploadButton>
      </BasicModal>
    );
  };

  readUrl = (file) => {
    const img = file.currentTarget.files[0];
    var reader = new FileReader();

    reader.readAsDataURL(img);

    reader.onload = () => {
      this.setState({
        showCropImageModal: true,
        projectIconForm: false,
        file: reader.result,
      });
    };
  };

  renderProjectImageModal = () => {
    const { openAddImageModal } = this.state;
    return (
      <BasicModal
        show={openAddImageModal}
        onHide={() => this.setState({ openAddImageModal: false })}
        title={"Add Image"}
      >
        <FileUploadButton htmlFor="imgupload">
          Upload Image
          <input
            type="file"
            id="imgupload"
            onChange={this.readUrl}
            name="avatar"
            style={{
              opacity: 0,
              position: "absolute",
              top: 0,
              left: 0,
            }}
            accept="image/png, image/jpeg"
          />
        </FileUploadButton>
      </BasicModal>
    );
  };

  deleteProjectImage = () => {
    const { imageToDeleteId } = this.state;

    const resolve = {
      onSuccess: () =>
        this.setState((prevState) => ({
          openDeleteImageModal: false,
          success: {
            ...prevState.success,
            deleteProjectImage: true,
          },
        })),
      onFailure: () => window.alert("There was an error!"),
    };
    this.props.deleteProjectImage(imageToDeleteId, resolve);
  };

  renderDeleteProjectImageConfirmationModal = () => {
    const { openDeleteImageModal, errors } = this.state;
    return (
      <ConfirmationModal
        show={openDeleteImageModal}
        onHide={() =>
          this.setState({
            openDeleteImageModal: false,
            errors: { deleteImage: null },
          })
        }
        title="Delete Image?"
        icon={<MdClose fontSize={30} color="red" />}
        buttonYes="danger"
        buttonNo="primary"
        onConfirm={() => this.deleteProjectImage()}
        error={errors.deleteImage}
      />
    );
  };

  _handleSubmitProjectImage = async (croppedImage) => {
    const { addProjectImage, projectDetails } = this.props;
    if (!projectDetails) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          projectImages: "Project not found",
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      fetching: {
        ...prevState.fetching,
        projectImages: true,
        cropImage: true,
      },
    }));

    const data = {
      id: projectDetails.id,
      image: croppedImage,
    };

    const resolve = {
      onSuccess: () => {
        this.setState((prevState) => ({
          showCropImageModal: false,
          success: true,
          fetching: {
            ...prevState.fetching,
            cropImage: false,
          },
        }));
      },
      onFailure: () =>
        this.setState((prevState) => ({
          error: true,
          success: false,
          fetching: {
            ...prevState.fetching,
            cropImage: false,
          },
        })),
    };

    await addProjectImage(data, resolve);
  };

  _handleSubmitAvatar = async (croppedImage) => {
    const { updateProjectAvatar, projectDetails } = this.props;
    if (!projectDetails) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          projectAvatar: "Project not found",
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      fetching: {
        ...prevState.fetching,
        projectAvatar: true,
        cropImage: true,
      },
    }));

    const data = {
      id: projectDetails.id,
      image: croppedImage,
    };

    const resolve = {
      onSuccess: () => {
        this.setState((prevState) => ({
          showCropImageModal: false,
          success: true,
          fetching: {
            ...prevState.fetching,
            cropImage: false,
          },
        }));
      },
      onFailure: () =>
        this.setState((prevState) => ({
          error: true,
          success: false,
          fetching: {
            ...prevState.fetching,
            cropImage: false,
          },
        })),
    };

    await updateProjectAvatar(data, resolve);
  };

  renderCropImageModal = () => {
    const {
      showCropImageModal,
      file,
      errors,
      imageType,
      fetching,
    } = this.state;
    return (
      <CropImageModal
        show={showCropImageModal}
        onHide={() =>
          this.setState({
            showCropImageModal: false,
          })
        }
        detail={file}
        handleSubmit={
          imageType === "avatar"
            ? this._handleSubmitAvatar
            : this._handleSubmitProjectImage
        }
        error={errors.cropImage}
        fetching={fetching.cropImage}
      />
    );
  };

  renderCropAvatarModel = () => {
    const { showCropAvatarModal, file, errors, fetching } = this.state;
    return (
      <CropImageModal
        show={showCropAvatarModal}
        onHide={() =>
          this.setState({
            showCropAvatarModal: false,
          })
        }
        detail={file}
        handleSubmit={this._handleSubmitAvatar}
        error={errors.cropImage}
        fetching={fetching.cropImage}
      />
    );
  };

  renderProjectUpdateFormModal = () => {
    const { projectUpdateFormModal } = this.state;
    return (
      <UpdateProjectForm
        handleSubmit={this.handleUpdateProject}
        openModal={projectUpdateFormModal}
        closeModal={() =>
          this.setState({
            projectUpdateFormModal: false,
          })
        }
      />
    );
  };

  editSave = () => {
    const {
      saveProject,
      projectDetails: { id },
    } = this.props;
    const { projectColor } = this.state;

    this.setState({
      saveProject: {
        fetching: true,
      },
    });

    const resolve = {
      onSuccess: () =>
        this.setState({
          saveProject: {
            fetching: false,
            error: false,
            success: true,
          },
        }),
      onFailure: (e) =>
        this.setState({
          saveProject: {
            fetching: false,
            error: e,
            success: false,
          },
        }),
    };

    const data = {
      id,
      color: projectColor,
    };

    saveProject(data, resolve);
  };

  _handleSubmit = async values => {
    const { updateProjectDetails, projectDetails } = this.props;

    this.setState(prevState => ({
      fetching: {
        ...prevState.fetching,
        projectDetails: true
      }
    }))

    const resolve = {
      onSuccess: () => {
        this.setState({
          error: null,
          success: true,
          fetching: {
            projectDetails: false
          }
        });
      },
      onFailure: e => {
        this.setState({
          error: e.message,
          success: false,
          fetching: {
            proejctDetails: false
          }
        });
      }
    };

    const data = {
      id: projectDetails.id,
      ...values
    }

    await  updateProjectDetails(data, resolve);
  };

  render() {
    const {
      projectDetails,
      projectImages,
    } = this.props;
    const { success, fetching } = this.state;
    if (success.delete) {
      return (
        <SweetAlert
          success
          confirmBtnText="Close"
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="default"
          title="Project deleted"
          onConfirm={() => this.props.history.push(navRoutes.myProjects)}
        >
          Your project has been removed
        </SweetAlert>
      );
    }

    if (Object.keys(projectDetails).length === 0) return <LoadingIcon />;

    return (
      <MainContainer>
        {this.renderDeleteProjectConfirmationModal()}
        {this.renderDeleteUpdateConfirmationModal()}
        {this.renderDeleteProjectImageConfirmationModal()}
        {this.renderLinksFormModal()}
        {this.renderDescriptionFormModal()}
        {this.renderProjectIconFormModal()}
        {this.renderProjectImageModal()}
        {this.renderCropImageModal()}
        {this.renderProjectUpdateFormModal()}
        <EditProjectForm
          handleSubmit={this._handleSubmit}
          projectDetails={projectDetails}
          editAvatar={() =>
            this.setState({ projectIconForm: true, imageType: "avatar" })
          }
          addProjectResource={() => this.setState({ openLinksForm: true })}
          projectImages={projectImages}
          addProjectImages={() =>
            this.setState({
              openAddImageModal: true,
              imageType: "projectImages",
            })
          }
          removeProjectImage={(id) => {
            this.setState({
              openDeleteImageModal: true,
              imageToDeleteId: id,
            });
          }}
          deleteProject={() => this.setState({ openDeleteModal: true })}
          fetching={fetching.projectDetails}
        />
      </MainContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    projectDetails: ProjectSelectors.getProjectDetails(state),
    projectUpdates: ProjectSelectors.getProjectUpdates(state),
    projectResources: ProjectSelectors.getProjectResources(state),
    user: AuthenticationSelectors.getUserDetails(state),
    projectImages: ProjectSelectors.getProjectImages(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectDetails: (data) =>
      dispatch(ProjectActions.projectDetailRequest(data)),
    updateProjectDetails: (data, resolve) =>
      dispatch(ProjectActions.updateProjectDetailsRequest(data, resolve)),
    updateProjectIcons: (data, resolve) =>
      dispatch(ProjectActions.updateProjectIconRequest(data, resolve)),
    addProjectResources: (data, resolve) =>
      dispatch(ProjectActions.addResourcesRequest(data, resolve)),
    deleteProject: (data, resolve) =>
      dispatch(ProjectActions.deleteProjectRequest(data, resolve)),
    deleteUpdate: (data, resolve) =>
      dispatch(ProjectActions.deleteProjectUpdateRequest(data, resolve)),
    createProjectUpdate: (data, resolve) =>
      dispatch(ProjectActions.createProjectUpdateRequest(data, resolve)),
    getProjectUpdates: (data, resolve) =>
      dispatch(ProjectActions.getProjectUpdatesRequest(data, resolve)),
    getProjectResources: (data) =>
      dispatch(ProjectActions.projectResourcesRequest(data)),
    getProjectImages: (data, resolve) =>
      dispatch(ProjectActions.getProjectImagesRequest(data, resolve)),
    deleteProjectImage: (data, resolve) =>
      dispatch(ProjectActions.deleteProjectImageRequest(data, resolve)),
    updateProjectAvatar: (data, resolve) =>
      dispatch(ProjectActions.updateProjectAvatarRequest(data, resolve)),
    addProjectImage: (data, resolve) =>
      dispatch(ProjectActions.addProjectImageRequest(data, resolve)),
    saveProject: (data, resolve) =>
      dispatch(ProjectActions.saveProjectRequest(data, resolve)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProjectContainer);
